var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _circle, _path, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKonqueror(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43000 43000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff1f1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39423,
    x2: 9410,
    y1: 34810,
    y2: 4798,
    xlinkHref: "#a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21500,
    x2: 37500,
    y1: 20500,
    y2: 36500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3355.1,
    x2: 32329,
    y1: 33449.1,
    y2: 41212.6,
    xlinkHref: "#a"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 14928,
    x2: 34051,
    y1: 10497,
    y2: 29630,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abf9c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54d883"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30905,
    x2: 15259,
    y1: 30221,
    y2: 9820,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#197cf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20bcfa"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22232.2,
    cy: 20938.6,
    r: 15000,
    fill: "url(#b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M19452 41384a20000 20000 0 004097 6l475-3100a17000 17000 0 003687-985l1956 2440a20000 20000 0 003549-2054l-1135-2910a17000 17000 0 002710-2695l2893 1127a20000 20000 0 002050-3553l-2422-1940a17000 17000 0 00609-1819 17000 17000 0 00369-1877l3094-475a20000 20000 0 006-4097l-3100-475a17000 17000 0 00-985-3687l2440-1956a20000 20000 0 00-2054-3549l-2910 1135a17000 17000 0 00-2695-2710l1127-2893a20000 20000 0 00-3554-2050l-1940 2422a17000 17000 0 00-1820-609 17000 17000 0 00-1877-369l-473-3094a20000 20000 0 00-4097-6l-477 3100a17000 17000 0 00-3687 986l-1956-2440a20000 20000 0 00-3549 2054l1135 2910a17000 17000 0 00-2710 2695L5315 9788a20000 20000 0 00-2050 3553l2422 1940a17000 17000 0 00-609 1819 17000 17000 0 00-369 1877l-3094 475a20000 20000 0 00-6 4097l3100 475a17000 17000 0 00985 3687l-2440 1956a20000 20000 0 002054 3549l2910-1135a17000 17000 0 002695 2710l-1127 2893a20000 20000 0 003553 2050l1940-2422a17000 17000 0 001819 609 17000 17000 0 001877 369zm-1575-6360a14000 14000 0 017247-27046 14000 14000 0 11-7247 27046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M30700 12307L12303 30694l10737 10734 506-37 475-3102c1262-190 2500-520 3688-984l1957 2440a19980 19980 0 003549-2055l-1135-2900a17090 17090 0 002709-2695l2893 1127a20020 20020 0 002051-3553l-2433-1949a16850 16850 0 00607-1818c158-618 283-1245 370-1877l3092-475 40-500z",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26000,
    height: 26000,
    x: 8500,
    y: 8500,
    fill: "url(#e)",
    rx: 13000
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M21500 8500c-944 0-1862 104-2747 293l-1153 2307-1742-1306a12960 12960 0 00-6665 7530l2557-1024 1950 1300 650-1950 8450-4550-515-2575a13600 13600 0 00-785-25m9627 4270l-527 1580 650 650-2600 3900 1300 4550 4310 540c155-806 240-1637 240-2500 0-2226-557-4316-1535-6145l-1065-345 387-776a13120 13120 0 00-1160-1455M8757 18899a13228 13228 0 00-248 2198l4540 1702-650-1950-1300-1950zm4292 3900l3250 7800v2820a13006 13006 0 005200 1080l385-10 4165-7140-10399-5849z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#172525",
    d: "M39383 12620l-2078 1666 270 783 2172-1740-363-710m-35758 6l-360 710 2154 1727 268-785zm-2092 8360c-30 854-4 1708 76 2560l3102 475c152 987 392 1960 715 2904l270-217a16920 16920 0 01-984-3688l-3102-475-76-1560m39934 20l-84 1540-3092 475c-88 632-212 1260-370 1877a17070 17070 0 01-607 1818l268 215 340-1033c160-618 283-1245 370-1877l3092-475a19930 19930 0 0084-2539m-2092 8360a20010 20010 0 01-1691 2842l-2893-1127a17010 17010 0 01-2709 2695l290 744a17050 17050 0 002418-2439l2893 1127a19960 19960 0 002051-3553zm-35758 6l-363 290a19980 19980 0 002055 3549l2900-1135c715 900 1520 1728 2400 2467l295-758a17010 17010 0 01-2695-2709l-2900 1135a19930 19930 0 01-1690-2840m24100 6928a16977 16977 0 01-3688 984l-475 3102a19974 19974 0 01-4098-8l-475-3092a17058 17058 0 01-1877-370 17070 17070 0 01-1818-607l-1940 2422a19940 19940 0 01-3242-1848l-310 797a19960 19960 0 003553 2051l1940-2422a16850 16850 0 001818 607c618 160 1245 283 1877 370l475 3092c1362 143 2735 145 4098 8l475-3102c1262-190 2500-520 3688-984l1957 2440a19980 19980 0 003549-2055l-310-795a20060 20060 0 01-3238 1850zM8530 21000l-25 500c0 7202 5798 13000 13000 13000s13000-5798 13000-13000c0-170-20-333-25-500-263 6966-5942 12500-12975 12500S8795 27966 8530 21000",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonqueror);
export default __webpack_public_path__ + "static/media/konqueror.3d5ac69ac922d23caeb76ce7b97787ed.svg";
export { ForwardRef as ReactComponent };